import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

/**
 * Where a password-reset email lands.
 *
 * The recovery link puts a session in the URL fragment, which the Supabase
 * client consumes on load because `detectSessionInUrl` is true (see
 * lib/supabase.ts — the app sets it to false and must, since it uses a deep
 * link instead). By the time this renders the user is transiently signed in and
 * `updateUser` is all that is left.
 */
export default function ResetPassword() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (!data.session) setError('This reset link has expired. Request a new one.');
      setReady(true);
    });
  }, []);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 6) { setError('Use at least 6 characters.'); return; }
    setBusy(true); setError(null);
    const { error: err } = await supabase.auth.updateUser({ password });
    setBusy(false);
    if (err) setError(err.message); else navigate('/');
  };

  return (
    <div className="auth">
      <div className="panel">
        <h1>New password</h1>
        <p className="sub">Choose a new password for your account.</p>
        {!ready ? <div className="notice">Checking your link…</div> : (
          <form onSubmit={submit}>
            <div className="field">
              <label htmlFor="new-password">New password</label>
              <input
                id="new-password" type="password" autoComplete="new-password" required
                value={password} onChange={e => setPassword(e.target.value)}
              />
            </div>
            {error && <div className="notice bad small" style={{ marginBottom: 14 }}>{error}</div>}
            <button className="primary" type="submit" disabled={busy} style={{ width: '100%' }}>
              {busy ? 'Saving…' : 'Save password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
